import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { useSelector } from 'react-redux';

const columns = [
	{ field: 'cart_id', headerName: 'CART ID', width: 200 },
	{
		field: 'type',
		headerName: 'TYPE',
		width: 150,
		editable: false,
	},
	{
		field: 'doj',
		headerName: 'DOJ',
		width: 150,
		editable: false,
	},
	{
		field: 'amount',
		headerName: 'AMOUNT',
		type: 'number',
		width: 150,
		editable: false,
	},
	{
		field: 'avail_bal',
		headerName: 'AVIALABLE BALANCE',
		width: 160,
		type: 'number',
		editable: false,
	},
	{
		field: 'payment_type',
		headerName: 'PAYMENT TYPE',
		type: 'number',
		width: 150,
		editable: false,
	},
	{
		field: 'date',
		headerName: 'DATE',
		type: 'number',
		width: 200,
		editable: false,
	},
	{
		field: 'description',
		headerName: 'DESCRIPTION',
		type: 'number',
		width: 300,
		editable: false,
	},
];

const rows = [
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
	{
		id: 'MFBF456895',
		depart: 'DEL',
		journey: 'DXB',
		dob: '8996',
		journeydate: '6546',
		cost: '7485',
		PTYPE: 'OFFLINE',
		DATE: '12/10/2022',
		DESC: 'FLIGHT BOOKING',
	},
];

export default function TransactionHistory() {
	const { transagent } = useSelector((state) => state.user);
	return (
		<Box sx={{ height: 600, width: '100%' }}>
			<DataGrid
				rows={transagent?.result?.result}
				columns={columns}
				initialState={{
					pagination: {
						paginationModel: {
							pageSize: 10,
						},
					},
				}}
				pageSizeOptions={[10]}
				checkboxSelection
				disableRowSelectionOnClick
			/>
		</Box>
	);
}
